
import Header from "./Header.vue";
import Menu from "./menu/Menu.vue";
import Footer from "./Footer.vue";
import { getMenuItems } from "./menu/MenuItemsLoader";
import { defineComponent, Ref, ref } from "vue";
import FooterGTop from "../../landingpageGTop/Footer.vue";
import { isGTopTemplate } from "../../mixins";

export default defineComponent({
  components: {
    FooterGTop,
    "my-menu": Menu,
    "my-header": Header,
    "my-footer": Footer
  },

  setup() {
    /** Controls menu's state. */
    const isMenuOpen: Ref<boolean> = ref(false);

    /** Contains all the menu's items. */
    const menuItems = getMenuItems();

    /** Used to control the close animation. */
    const userAlreadyToggle: Ref<boolean> = ref(false);

    /** Used to toggle the menu. Can be called by an event coming from the menu
     * or from the header that contains the menu. */
    const toggleMenu = (): void => {
      isMenuOpen.value = !isMenuOpen.value;
      if (!userAlreadyToggle.value) userAlreadyToggle.value = true;
    };

    return {
      toggleMenu,
      isGTopTemplate,
      isMenuOpen,
      menuItems,
      userAlreadyToggle
    };
  }
});
